export default __webpack_public_path__ + "static/media/61_mobile.b4b154db.jpg";